// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function modifications_tentative_status_encode(v) {
  return Js_dict.fromArray([
              [
                "external_id",
                Decco.stringToJson(v.external_id)
              ],
              [
                "tentative_status",
                Decco.stringToJson(v.tentative_status)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "core_pricing_external_id",
                Decco.stringToJson(v.core_pricing_external_id)
              ],
              [
                "modifications_tentative_statuses",
                Decco.listToJson(modifications_tentative_status_encode, v.modifications_tentative_statuses)
              ],
              [
                "prioritized_modification_ids",
                Decco.listToJson(Decco.stringToJson, v.prioritized_modification_ids)
              ]
            ]);
}

export {
  modifications_tentative_status_encode ,
  t_encode ,
  
}
/* No side effect */
